import React from 'react';
import { Box, Card, Grid } from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import {
  cardStyle,
  iconStyleGreen,
  iconStyleOrange,
  textStyles,
} from './EquipmentStatusCardStyles';

const EquipmentStatusCard = ({ data }) => {
  const iconStyleBlue = { ...iconStyleGreen, color: '#1976d2' }; // Blue for available
  const iconStyleRed = { ...iconStyleGreen, color: '#d32f2f' };  // Red for not available

  return (
    <Card sx={cardStyle}>
      <span style={textStyles.title}>Equipment Status</span>
      <Grid container spacing={2} justifyContent="space-around" alignItems="center">
        <Grid item>
          <Box textAlign="center">
            <WorkIcon sx={iconStyleGreen} />
            <span style={textStyles.count}>{data?.activeEquipments || 0}</span>
            <span style={textStyles.labelActive}>Active</span>
          </Box>
        </Grid>
        <Grid item>
          <Box textAlign="center">
            <WorkIcon sx={iconStyleOrange} />
            <span style={textStyles.count}>{data?.inactiveEquipments || 0}</span>
            <span style={textStyles.labelInactive}>Inactive</span>
          </Box>
        </Grid>
        <Grid item>
          <Box textAlign="center">
            <WorkIcon sx={iconStyleBlue} />
            <span style={textStyles.count}>{data?.availableEquipment || 0}</span>
            <span style={textStyles.labelAvailable}>Available</span>
          </Box>
        </Grid>
        <Grid item>
          <Box textAlign="center">
            <WorkIcon sx={iconStyleRed} />
            <span style={textStyles.count}>{data?.unavailableEquipment || 0}</span>
            <span style={textStyles.labelNotAvailable}>Not Available</span>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};

export default EquipmentStatusCard;
